<template lang="pug">
.mt-4
  transition(name="fade", mode="out-in", appear)
    .text-center(v-if="loading", key="loading")
      v-progress-circular(:size="64", indeterminate)

    div(v-else, key="content")
      .mb-4.pa-6.rounded(:class="statusIndex === 7 ? 'expert-bg' : 'bg'")
        template(v-if="statusIndex <= 8")
          div
            div
              | This is the template of your
              | Sponsor licence online application,
              | it will be uploaded
              | to the Home Office website
              | once approved by an expert.

              template(v-if="![5, 6, 8].includes(statusIndex)")
                |
                | You can't edit your answers on here,
                | but you can change them in the
                |
                a(@click="$router.push('/company')")
                  | Company profile
                | ,
                |
                a(@click="$emit('goto', 2)")
                  | Case profile
                | ,
                |
                a(@click="$emit('goto', 3)")
                  | Candidate
                | ,
                | and
                |
                a(@click="$emit('goto', 4)")
                  | Documents
                |
                | tabs.

            br(v-if="statusIndex >= 4")

        template(v-if="statusIndex <= 3")
          br

          div
            v-icon.mr-2(color="error")
              | mdi-alert-decagram

            span
              | It will appear once you
              | finalise all your steps.
              |
              a(@click="$emit('goto', 0)")
                | Show steps

        template(v-if="statusIndex === 4")
          .d-flex.justify-space-between
            div
              div
                | Status: not submitted yet
                | for an expert review.

              br

              div
                | Please review and make sure
                | that everything presented is correct.
                | Once you are ready, please submit
                | your case for an expert review.

              br

              div
                | If you have any questions,
                | please don’t hesitate
                | to contact us via chat.

            .pl-4
              v-btn(
                width="250",
                color="green lighten-2",
                @click="submitCaseForReview"
              ) submit case for review

        template(v-if="[5, 6, 8].includes(statusIndex)")
          .d-flex.justify-space-between
            div
              div
                | Status: submitted
                | for an expert review,
                | case is locked.

              br

              div
                | You won’t be able to change
                | any information in your case
                | until the expert approves your case
                | or comes back with
                | further questions and instructions.

              br

              div
                | If there are any changes
                | you’d like to make in your case,
                | please contact us via chat.

            .pl-4
              v-btn(width="250", color="green lighten-2", disabled)
                | submit case for review

        template(v-if="statusIndex === 7")
          .d-flex.justify-space-between
            div
              div
                | Status: further actions required.

              br

              div
                | The expert has reviewed
                | your application,
                | and further actions
                | from you are required.
                | Please see the comments below.

              div(v-html="expertComment")

              br

              div
                | Please make the requested changes,
                | review, and confirm
                | that everything presented is correct.
                | Once you are ready,
                | please re-submit your case
                | for an expert review.

              br

              div
                | If you have any questions,
                | please don’t hesitate
                | to contact us via chat.

            .pl-4
              v-btn(width="250", color="primary", @click="submitCaseForReview")
                | submit case for review

        template(v-if="statusIndex === 9")
          div
            .text-h6.text-center
              b
                span
                  | Your case has been approved
                  | and your Sponsor licence application
                  | has been generated

                br

                span
                  | on the Home Office website!

            br

            div
              | Note: Nation.better’s work
              | has been completed,
              | and it is now your responsibility
              | to make sure that you are happy
              | with the information
              | presented in your online application.
              | Nation.better have simply transferred
              | the provided data by you as per
              |
              a(
                href="https://drive.google.com/file/d/1Dd14rV-LRKpweIpemMZJj250S1Tg99l0/view?usp=sharing",
                target="_blank"
              )
                | Terms and Conditions.

            br

            div
              | Follow the steps below
              | to complete the process:

            br

            ul(style="list-style-type: decimal")
              li.mb-2
                | Login into your online application
                | by using ‘Login’ credentials below
                | -
                | review all information presented
                | and make sure it is correct;
              li.mb-2
                | Your Authorising Officer
                | will need to sign a declaration
                | (it is a ‘tick’ box at the end
                | of an online application)
                | and process a payment
                | -
                | this constitutes the submission;

              br

              div
                | Note: After submission,
                |
                b
                  | don’t forget to download
                  | the submission sheet
                |
                | (you can do this
                | through the ‘Print’ option
                | and save the form as a PDF file).
                | Alternatively, you can print
                | your submission sheet out,
                | make a photo of it for your records.
                | There will be no other opportunity
                | to print it or save it later.

              br

              li
                | Notify us that you submitted
                | an online application,
                | and we’ll immediately provide you
                | with a list of supporting documents
                | along with the Cover Letter
                | that you’ll send to the Home Office.

          .py-12.d-flex.justify-center
            v-dialog(
              ref="dialog",
              width="300",
              persistent,
              :return-value.sync="date",
              v-model="modal"
            )
              template(v-slot:activator="{ on, attrs }")
                v-text-field.mr-4(
                  style="max-width: 250px",
                  outlined,
                  dense,
                  readonly,
                  append-icon="mdi-calendar",
                  placeholder="YYYY-MM-DD",
                  label="Select date",
                  v-on="on",
                  v-bind="attrs",
                  v-model="date"
                )
              v-date-picker(v-model="date", scrollable)
                v-spacer
                v-btn(text, color="primary", @click="modal = false")
                  | cancel
                v-btn(text, color="primary", @click="$refs.dialog.save(date)")
                  | ok

            v-btn(
              width="250",
              color="green lighten-2",
              :disabled="!dateValid",
              @click="confirmSubmission"
            ) confirm submission

        template(v-if="statusIndex === 10")
          div
            .text-h6.text-center
              | Here is the list of supporting documents
              | that you should send to the Home Office
          br

          div
            | You must send all supporting documents
            | (including submission sheet and cover letter)
            | to the email address
            | SponsorLicensingReplies@homeoffice.gov.uk
            | (please also check the email address
            | on your submission sheet)
            | within 5 working days of the date
            | you complete your online application.

          br

          DocumentTable(:items="documents")

          br

          div
            | If you need our assistance and support
            | with follow-up communication
            | with the Home Office,
            | please contact us via chat.

        template(v-if="[9, 10].includes(statusIndex) && credits")
          .mt-4.mb-2.text-subtitle-2
            | Log in details
          v-row.mt-0(v-for="(item, i) in credits", :key="i", no-gutters)
            v-col(cols="2")
              span(v-text="item.label")
            v-col
              a.text-decoration-none(
                v-if="item.link",
                target="_blank",
                :href="item.value",
                v-text="item.value"
              )
              span(v-else, v-text="item.value")

      template(v-if="statusIndex >= 4")
        .mb-4.d-flex.justify-end
          v-btn(v-if="allTabsOpened", width="150", @click="opened = []")
            | collapse all
          v-btn(v-else, width="150", @click="opened = tabIndexes")
            | expand all

        v-expansion-panels(hover, multiple, v-model="opened")
          v-expansion-panel(v-for="(tab, i) in tabs", :key="i")
            v-expansion-panel-header
              .title
                | {{ i + 1 }}. {{ tab.title }}

            v-expansion-panel-content
              .pt-4
                template(v-if="tab.title === 'Documents'")
                  .pa-4.rounded.bg
                    div
                      | Here is the list of documents
                      | you've uploaded for expert review.

                    br

                    DocumentTable(:items="tab.items")

                template(v-else-if="tab.subs")
                  .pa-4.rounded.bg(
                    v-for="(sub, j) in tab.subs",
                    :key="j",
                    :class="[!!j && 'mt-4']"
                  )
                    .mb-4.subtitle-1.font-weight-bold(
                      v-if="sub.title",
                      v-text="sub.title"
                    )
                    v-row.mb-2(
                      v-for="(item, k) in sub.items",
                      :key="k",
                      no-gutters
                    )
                      v-col(cols="5")
                        span(v-text="item.label")
                      v-col.ml-4
                        div(
                          v-for="value in item.value",
                          :key="value",
                          v-text="value"
                        )

                template(v-else)
                  .pa-4.rounded.bg
                    v-row.mb-2(
                      v-for="(item, j) in tab.items",
                      :key="j",
                      no-gutters
                    )
                      v-col(cols="5")
                        span(v-text="item.label")
                      v-col.ml-4
                        span(v-text="item.value")
</template>

<script>
import { mapGetters, mapState } from "vuex";
import DocumentTable from "./components/DocumentTable";
import { prettifyValue } from "@/utils/prettifyValue";

export default {
  name: "employer-case-online_application",

  components: {
    DocumentTable,
  },

  data: () => ({
    reqCount: 0,
    opened: [],
    modal: false,
    date: null,
    coverLetter: null,
  }),

  computed: {
    ...mapGetters("usercase", ["currentUsercase", "ID", "statusIndex"]),
    ...mapState("usercase/sponsorship", {
      OAData: (state) => state.onlineApplication,
      loading: (state) => state.loading.onlineApplication,
    }),

    documents() {
      const docs = [];
      (this.currentUsercase?.documents || []).forEach((el) => {
        if (el.files?.length > 0) docs.push(el);
      });
      if (this.statusIndex === 10) {
        docs.unshift({
          inaccessible: true,
          status: "Mandatory",
          label: "Cover letter",
          url: `/employer/case/${this.ID}/sponsorship/cover_letter?pdf`,
          filename: "cover-letter.pdf",
        });
        docs.push({
          inaccessible: true,
          warning: true,
          status: "Mandatory",
          label: "Submission sheet",
        });
      }
      return docs;
    },

    expertComment() {
      return this.currentUsercase?.expert_comment;
    },

    credits() {
      return [
        {
          label: "Website",
          value: this.currentUsercase?.ukvi_link ?? "-",
          link: true,
        },
        {
          label: "User ID",
          value: this.currentUsercase?.ukvi_login ?? "-",
        },
        {
          label: "Password",
          value: this.currentUsercase?.ukvi_password ?? "-",
        },
      ];
    },

    tabs() {
      if (!this.OAData) return [];
      // console.log(
      //   this.OAData.map((category) =>
      //     category.subs.map((sub) =>
      //       sub.items.map((item) => [item.label, item?.value])
      //     )
      //   )
      // );
      const tabs = [
        ...this.OAData.map((category) => ({
          title: category.title,
          subs: category.subs.map((sub) => ({
            title: sub.title,
            items: sub.items.map((item) => ({
              label: item.label,
              value: item?.value.map((v) => prettifyValue(v)),
            })),
          })),
        })),
      ];
      if (this.statusIndex !== 10)
        tabs.push({
          title: "Documents",
          items: this.documents,
        });
      return tabs;
    },

    allTabsOpened() {
      return this.opened.length === this.tabs.length;
    },

    tabIndexes() {
      return this.tabs.map((tab, i) => i);
    },

    dateValid() {
      return !!this.date;
    },
  },

  methods: {
    getData() {
      this.$store.dispatch("usercase/sponsorship/refreshOnlineApplication");
    },

    submitCaseForReview() {
      this.reqCount += 1;
      const url = `/employer/case/${this.ID}/sponsorship/send_to_review`;
      this.axios
        .get(url)
        .then(() => this.$store.dispatch("usercase/refreshUsercaseList"))
        .catch((err) => console.error(err))
        .finally(() => (this.reqCount -= 1));
    },

    confirmSubmission() {
      this.reqCount += 1;
      const url = `/employer/case/${this.ID}/sponsorship/confirm_oa`;
      const data = { date: this.date };
      this.axios
        .post(url, data)
        .then(() => this.$store.dispatch("usercase/refreshUsercaseList"))
        .catch((err) => console.error(err))
        .finally(() => (this.reqCount -= 1));
    },

    requestChange() {
      this.reqCount += 1;
      const url = `/employer/case/${this.ID}/sponsorship/request_change`;
      this.axios
        .post(url)
        .then(() => {
          // console.log(resp.data);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.reqCount -= 1;
        });
    },
  },

  created() {
    this.$store.dispatch("usercase/refreshUsercaseList");
    this.getData();
  },
};
</script>

<style lang="sass" scoped>
.bg
  background: #f8f9fc

.expert-bg
  background: #fb8c0026
</style>